// test402
(402 && 0);
